import React, { useRef, useEffect } from 'react';
import moment from "moment";

const ViewModal = ({ isOpen, onClose, data, field }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [isOpen, onClose]);

    return (
        <>
            {isOpen && (
                <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                    <div
                        className="modal-dialog modal-dialog-centered"
                        ref={modalRef}
                        style={{ minWidth: '40%' }}
                    >
                        <div className="modal-content" style={{ height: 'auto', overflow: 'auto' }}>
                            <div className="modal-header">
                                <h5 className="modal-title" id="staticBackdropLabel" style={{ fontSize: "22px" }}>
                                    {field.title}
                                </h5>
                                <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label"><b>{field._title}:</b></label>
                                    <div className="form-control">{data.title}</div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label"><b>{field.message}:</b></label>
                                    <p className="form-control">+{data.message}</p>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label"><b>{field.language}:</b></label>
                                    <p className="form-control">{data?.notification_language?.name}</p>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label"><b>{field.date}:</b></label>
                                    <p className="form-control">{moment(data.createdAt).format("DD-MM-YYYY")}</p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isOpen && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default ViewModal;
